import http from '../../../services/http';
import { dashboardActions } from '../../entities/dashboard';

const path = 'api/dashboard/professor';

const allClassesDetails = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/classesdetails`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const allClasses = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/allclasses`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const show = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/singleclassdetails/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const classGrades = ({ onSuccess, onError, onEnd, id = '', missing, submitted }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/classgrades/${id}?missing=${missing}&submitted=${submitted}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const deleteInstructors = ({ onSuccess, onError, onEnd, body, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/class/delete/instructors/${id}`,
        body,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const instructors = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/class/instructors/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const classStudents = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/classstudents/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const activityAnswersBystudent = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/activityanswersbystudent/${id}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const allStudents = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/allstudents`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });

      dispatch(dashboardActions.setStudents(res.data.data));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const allActivities = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/allactivities`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      dispatch(dashboardActions.setActivities(res.data.data));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const countGraded = ({ onSuccess, onError, onEnd, id = '' }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/gradecount`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      dispatch(dashboardActions.setTotalGraded(res.data.data.gradedAnswers));
      dispatch(dashboardActions.setTotalAnswers(res.data.data.totalAnswers));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

const updateActivityGrade = ({ onSuccess, onError, onEnd, activityId, grade }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.post({
        url: path + `/acitivity/${activityId}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
        body: { grade, activityId },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      onError?.(error);
    } finally {
      onEnd?.();
    }
  };
};
const library = ({ onSuccess, onError, onEnd, search }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/books?search=${search}`,
        headers: {
          'x-auth-token': store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      onError?.(error);
    } finally {
      onEnd?.();
    }
  };
};

export {
  show,
  allClasses,
  classGrades,
  instructors,
  classStudents,
  allClassesDetails,
  deleteInstructors,
  updateActivityGrade,
  activityAnswersBystudent,
  allStudents,
  allActivities,
  countGraded,
  library,
};
